import { render, staticRenderFns } from "./config_gallery.vue?vue&type=template&id=4e9e8f45&scoped=true"
import script from "./config_gallery.vue?vue&type=script&lang=js"
export * from "./config_gallery.vue?vue&type=script&lang=js"
import style0 from "./config_gallery.vue?vue&type=style&index=0&id=4e9e8f45&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9e8f45",
  null
  
)

export default component.exports